import { trackInternalEvent } from '@rio/tracking'
import Button, { ButtonTheme } from 'builder/components/Button'
import { goToBillingPlanPage } from 'builder/utils/goToBillingPlanPage'
import { useGetLowestPrice } from 'builder/views/Interview/hooks/useGetLowestPrice'
import { useI18n } from 'builder/hooks/useI18n'
import { ButtonContainer, CrownIcon } from './styles'

export const TRANSLATION_PREFIX = `builder.interview_prep_view.feedbackV2.paywall`
export const BtnUpgrade = ({ section }: { section: 'ideal_answer' | 'feedback' }) => {
  const { data: price } = useGetLowestPrice()
  const { i18n } = useI18n()

  return (
    <ButtonContainer>
      <Button
        theme={ButtonTheme.alternative}
        onClick={() => {
          goToBillingPlanPage({
            forceReferrerPage: 'interviewPrep',
            onSuccessRedirect: window.location.pathname,
          })
          trackInternalEvent('click_upgrade_paywall', {
            label: 'interview_prep',
            parameter: 'feedback',
          })
        }}
      >
        <CrownIcon />
        {i18n.t(`${TRANSLATION_PREFIX}.unlock_button_${section}`, { price })}
      </Button>
    </ButtonContainer>
  )
}
